import { angleTo, turnDir } from './math.js';
import { EMPTY_INPUT, type Controller, type PlaneInput, type SimState } from './sim.js';
export class DuelPilot implements Controller {
  poll(state: SimState, side: 0 | 1, _rng: import('./rng.js').SeededRandom): PlaneInput {
    const p = state.planes[side]!;
    const foe = state.planes[1 - side]!;
    const i: PlaneInput = { ...EMPTY_INPUT, fire: true };
    if (p.v !== 0) return i;
    if (p.a === 0) {
      i.climb = true;
      return i;
    }
    if (p.a !== 1) return i;
    if (p.g < 240) i.climb = true;
    const sx = p.x >> 6;
    const sy = p.y >> 6;
    const aimAt = (tx: number, ty: number): void => {
      const a = angleTo(p.x, p.y, tx * 64, ty * 64);
      const diff = turnDir(p.h, a);
      if (diff >= 2) {
        if (diff === 2) i.left = true;
        else i.right = true;
      }
    };
    if (sy > 178) aimAt(sx, sy - 40);
    else if (sy > 162 && sx > 92 && sx < 162) aimAt(sx, sy - 40);
    else if (sy > 174) aimAt(sx, sy - 30);
    else aimAt(foe.x >> 6, Math.min(foe.y >> 6, 170));
    return i;
  }
}
